export default __webpack_public_path__ + "static/smartview-adbb36d79ad3dcd46e1d28bcf31f2704.png";